import React, { useState } from 'react'

import * as triggerStyle from './Trigger.styles'
import { TriggerDisabledLabel } from './TriggerDisabledLabel'

interface TriggerProps {
  id: string
  icon: React.ReactNode
  content: React.ReactNode

  selected?: boolean
  disabled?: boolean
  showDisabledLabel?: boolean

  isClickableTrigger?: boolean
  onClick?: () => void
}

export const TriggerView = React.memo((props: TriggerProps) => {
  const { icon, content, selected, disabled, showDisabledLabel, isClickableTrigger, onClick } =
    props

  const [isHover, setIsHover] = useState(false)

  const onMouseOver = () => {
    setIsHover(true)
  }

  const onMouseOut = () => {
    setIsHover(false)
  }

  const wrapperStyle = React.useMemo(
    () => ({
      ...triggerStyle.CommonViewStyle,
      ...(disabled ? triggerStyle.DisabledCommonViewStyle : {}),
      ...(selected || isHover ? triggerStyle.SelectedCommonViewStyle : {}),
    }),
    [disabled, isHover, selected],
  )

  return (
    <view
      name={props.id}
      style={wrapperStyle}
      onMouseOver={isClickableTrigger ? onMouseOver : undefined}
      onMouseOut={isClickableTrigger ? onMouseOut : undefined}
      cursor={isClickableTrigger ? 'pointer' : 'default'}
      onClick={isClickableTrigger ? onClick : undefined}
    >
      <view style={triggerStyle.ViewStyle}>
        {icon}
        <view style={triggerStyle.TextViewStyle}>{content}</view>
      </view>
      <TriggerDisabledLabel isVisible={Boolean(showDisabledLabel)} />
    </view>
  )
})
